// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentionRenderer__mentioned-user-ac3605 {
  color: var(--chat-bubble-primary);
  cursor: pointer;
  user-select: all;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/TextRenderer/renderTree/MentionRenderer/MentionRenderer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AACF","sourcesContent":[".mentioned-user {\n  color: var(--chat-bubble-primary);\n  cursor: pointer;\n  user-select: all;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mentioned-user": `MentionRenderer__mentioned-user-ac3605`,
	"mentionedUser": `MentionRenderer__mentioned-user-ac3605`
};
module.exports = ___CSS_LOADER_EXPORT___;
